/**
 *  Alaska: Notification
 *  @version 2.0
 *
 *  Changelog:
 *      - Notifications are now stackable.
 *      - Notifications can now be queued and will render on next page-load.
 */

class Notification {

    static render(message, type = "info") {
        if (typeof message !== "string" || !message) {
            console.error("Invalid message provided for Notification.render.");
            return;
        }

        const notification_container = this.get_container();
        const notification_element = this.render_notification(message, type);

        notification_container.appendChild(notification_element);
        this.animate_notification(notification_element);
    }

    static queue(message, type) {
        let object = {
            message: message,
            type: type
        };

        let encoded_message = JSON.stringify(object);
        sessionStorage.setItem('notification', encoded_message);
    }

    static render_queued_messages() {
        const queued = sessionStorage.getItem('notification');
        if (queued) {
            const notification_obj = JSON.parse(queued);

            if (notification_obj && notification_obj.message && notification_obj.type) {
                Notification.render(notification_obj.message, notification_obj.type);
            }
        }

        sessionStorage.removeItem('notification');
    }

    static escape_html(input) {
        if (typeof input !== "string") {
            return "";
        }
        return input.replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    static render_notification(message, type) {
        const notification = document.createElement("div");
        notification.classList.add("notification", type);
        notification.setAttribute("role", "alert");
        notification.setAttribute("aria-live", "assertive");

        notification.innerHTML = this.escape_html(message);

        const close_icon = document.createElement("i");
        close_icon.className = "close-notification cursor-pointer text-xl fa-solid fa-times";
        close_icon.addEventListener("click", () => {
            console.log("click");
            notification.style.opacity = 0;
            setTimeout(() => notification.remove(), 300);
        });

        notification.appendChild(close_icon);

        return notification;
    }

    static animate_notification(notification) {
        requestAnimationFrame(() => {
            notification.style.opacity = 1;
        });

        setTimeout(() => {
            notification.style.opacity = 0;
            setTimeout(() => notification.remove(), 300);
        }, 5000);
    }

    static get_container() {
        let container = document.querySelector(".notification-stack");
        if (!container) {
            container = document.createElement("div");
            container.className = "notification-stack";
            document.body.appendChild(container);
        }
        return container;
    }
}

Notification.render_queued_messages();

window.Notification = Notification;